@if (incomeTaxEntity$ | async) {
    @if ((optellingPga$ | async)! > 0) {
        @if (aangifteRapport) {
            <snelstart-venture-fiscaal-feature-spec-zorgkosten
                    [rapport]="aangifteRapport"></snelstart-venture-fiscaal-feature-spec-zorgkosten>
            <snelstart-venture-fiscaal-feature-spec-giften
                    [rapport]="aangifteRapport"></snelstart-venture-fiscaal-feature-spec-giften>
            <snelstart-venture-fiscaal-feature-spec-scholing
                    [rapport]="aangifteRapport"></snelstart-venture-fiscaal-feature-spec-scholing>
            <snelstart-venture-fiscaal-feature-spec-overige-pga
                    [rapport]="aangifteRapport"></snelstart-venture-fiscaal-feature-spec-overige-pga>
        }
        @if (dataVisible$ | async) {
            <form [formGroup]="formGroup">
                <div>
                    <div class="row">
                        <div class="col col-1">
                            <p><b>Totaal persoonsgebonden aftrek</b></p>
                        </div>
                        <div class="col-2"></div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control [decimals]="0"
                                                              [disabledControl]="true"
                                                              align="right"
                                                              class="custom-input-150"
                                                              formControlName="totaalPga"
                                                              id="totaalPga"
                                                              prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-2"></div>
                    </div>
                </div>
            </form>
        }
    } @else {
        <p>Er zijn geen aftrekbare persoonsgebonden aftrekposten in de aangifte ingevuld.</p>
    }
}
